module.exports = __webpack_public_path__ + "img/mini.360c6d92.png";